import { compose } from 'ramda';
import { createAction } from 'redux-actions';

import logError from 'app/error/logError';
import { MANGAS_FETCHED } from 'app/features/mangas/actionTypes';

const mangasFetched = createAction(MANGAS_FETCHED);

function fetchMangas() {
  return (dispatch, getState, { api }) =>
    api.fetchMangas().then(compose(dispatch, mangasFetched)).catch(logError);
}

export default fetchMangas;
